import { IDefinition } from "../../../../system/pdfController";
import { IShiftReportMS } from "./types";
import { formatDate, formatTimeWithSeconds } from "../../../../system/utils";
import { Duration } from "luxon";

export const generateDefinition = (item: IShiftReportMS): IDefinition => {
  const content = item.content!;
  const maintenanceSAP = content.maintenanceSAP;

  const delaysData: any[] = [];

  (content && content.delays ? content.delays.list : []).forEach(row => {
    const duration = Duration.fromMillis((row.duration ?? 0) * 1000).toFormat("hh:mm:ss");

    delaysData.push([
      { text: "", style: "tableSubTitle", alignment: "justify" },
      { text: "Start Time", style: "tableSubTitle", alignment: "justify" },
      { text: "Duration", style: "tableSubTitle", alignment: "justify" },
      { text: "Responsibility", style: "tableSubTitle", alignment: "justify" },
      { text: "Area", style: "tableSubTitle", alignment: "justify" },
      { text: "Equipment", style: "tableSubTitle", alignment: "justify", colSpan: 2 },
      {}
    ]);

    delaysData.push([
      { text: "", style: "tableSubTitle", alignment: "justify" },
      { text: formatTimeWithSeconds(row.beginDatetime), style: "tableCell", alignment: "justify" },
      { text: duration, style: "tableCell", alignment: "justify" },
      { text: row.responsibility, style: "tableCell", alignment: "justify" },
      { text: row.area, style: "tableCell", alignment: "justify" },
      { text: row.equipment, style: "tableCell", alignment: "justify", colSpan: 2 },
      {}
    ]);

    delaysData.push([
      { text: "Observation", style: "tableSubTitle", alignment: "justify" },
      { text: row.observation, style: "tableCell", alignment: "justify", colSpan: 6 },
      {},
      {},
      {},
      {},
      {}
    ]);

    delaysData.push([
      { text: "Notes", style: "tableSubTitle", alignment: "justify" },
      { text: row.comment, style: "tableCell", alignment: "justify", colSpan: 6 },
      {},
      {},
      {},
      {},
      {}
    ]);
  });

  const sapNotificationItems = maintenanceSAP
    ? maintenanceSAP.items.map(item => {

      return [
        { text: item.failureReported, style: "tableCell", colSpan: 4  },
        { },
        { },
        { },
        { text: item.notificationNr, style: "tableCell" },
      ]
    })
    :  [[
      { text: "", style: "tableCell", colSpan: 5  },
      { },
      { },
      { },
      { }
    ]];

  return {
    info: {
      title: `Shift Report - ${item.shift.name.toLowerCase()} - ${formatDate(item.shift.factoryDay)}`,
      author: "Optimus Steel",
    },
    // pageSize: "A5",
    // pageOrientation: "landscape",
    content: [
      {
        image: "data:image/png;base64,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",
        width: 30
      },
      {
        text: "Shift Report",
        style: "header",
        alignment: "center"
      },
      {
        style: "table",
        color: "#444",
        table: {
          widths: [180, "*", "*", "*", "*"],
          headerRows: 0,
          // keepWithHeaderRows: 1,
          body: [
            [
              { text: "Supervisor", style: "tableTitle" },
              { text: "Area", style: "tableTitle", alignment: "center", colSpan: 2 },
              { },
              { text: "Date", style: "tableTitle", alignment: "center" },
              { text: "Shift", style: "tableTitle", alignment: "center" },
            ],
            [
              { text: item.user?.userName.toUpperCase(), style: "tableHeader" },
              { text: item.area.name.toUpperCase(), style: "tableHeader", alignment: "center", colSpan: 2 },
              { },
              { text: formatDate(item.shift.factoryDay), style: "tableHeader", alignment: "center" },
              { text: item.shift.name.toUpperCase(), style: "tableHeader", alignment: "center" },
            ]
          ]
        }
      },
      {
        style: "table",
        color: "#444",
        table: {
          widths: [180, "*", "*", "*", "*"],
          headerRows: 0,
          // keepWithHeaderRows: 1,
          body: [
            [
              { text: "Safety Results", style: "tableSafety", colSpan: 5 },
              {},
              {},
              {},
              {},
            ],
            [
              { text: "Incidents", style: "tableHeader" },
              { text: content.safetyResult.incidents.value ? "YES" : "NO", style: "tableCell", alignment: "justify" },
              { text: content.safetyResult.incidents.comment, style: "tableCell", alignment: "justify", colSpan: 3 },
              {},
              {}
            ],
            [
              { text: "PRA's & Contracting Out", style: "tableHeader" },
              { text: content.safetyResult.prasAndContractingOut.value ? "YES" : "NO", style: "tableCell", alignment: "justify" },
              { text: content.safetyResult.prasAndContractingOut.comment, style: "tableCell", alignment: "justify", colSpan: 3 },
              {},
              {}
            ],
          ]
        }
      },
      {
        style: "table",
        color: "#444",
        table: {
          widths: [180, "*", "*", "*", "*"],
          headerRows: 0,
          // keepWithHeaderRows: 1,
          body: [
            [
              { text: "Quality Results", style: "tableQuality", colSpan: 5 },
              {},
              {},
              {},
              {},
            ],
            [
              { text: "Incidents", style: "tableHeader" },
              { text: content.quality ? content.quality.incidents.value ? "YES" : "NO" : "", style: "tableCell", alignment: "justify" },
              { text: content.quality ? content.quality.incidents.comment : "", style: "tableCell", alignment: "justify", colSpan: 3 },
              {},
              {}
            ]
          ]
        }
      },
      {
        style: "table",
        color: "#444",
        table: {
          widths: [180, "*", "*", "*", "*"],
          headerRows: 0,
          // keepWithHeaderRows: 1,
          body: [
            [
              { text: "Production Results", style: "tableProduction", colSpan: 5 },
              {},
              {},
              {},
              {},
            ],
            [
              { text: "Heats during shift", style: "tableHeader" },
              { text: content.production.heatsDuringShift.value, style: "tableCell", alignment: "justify" },
              { text: content.production.heatsDuringShift.comment, style: "tableCell", alignment: "justify", colSpan: 3 },
              {},
              {}
            ],
            [
              { text: "Power On", style: "tableHeader" },
              { text: content.production.powerOn.value, style: "tableCell", alignment: "justify" },
              { text: content.production.powerOn.comment, style: "tableCell", alignment: "justify", colSpan: 3 },
              {},
              {}
            ],
            [
              { text: "Power Off", style: "tableHeader" },
              { text: content.production.powerOff.value, style: "tableCell", alignment: "justify" },
              { text: content.production.powerOff.comment, style: "tableCell", alignment: "justify", colSpan: 3 },
              {},
              {}
            ],
            [
              { text: "Total Production", style: "tableHeader" },
              { text: content.production.totalProduction.value, style: "tableCell", alignment: "justify" },
              { text: content.production.totalProduction.comment, style: "tableCell", alignment: "justify", colSpan: 3 },
              {},
              {}
            ],
            [
              { text: "Charge Weight", style: "tableSubTitle" },
              { text: "Heat #", style: "tableSubTitle", alignment: "justify" },
              { text: "Weight", style: "tableSubTitle", alignment: "justify", colSpan: 3 },
              {},
              {},
            ],
            ...content.production.chargeWeight.map(h => {

              return [
                { text: "", style: "tableHeader" },
                { text: h.heat, style: "tableCell", alignment: "justify" },
                { text: h.weight, style: "tableCell", alignment: "justify" },
                { text: "", style: "tableCell", alignment: "justify", colSpan: 2  },
                {}
              ];
            }),
            [
              { text: "Missed heats", style: "tableHeader" },
              { text: content.production.missedHeats.value, style: "tableCell", alignment: "justify" },
              { text: content.production.missedHeats.comment, style: "tableCell", alignment: "justify", colSpan: 3 },
              {},
              {}
            ],
            [
              { text: "Metallic yield loss", style: "tableHeader" },
              { text: content.production.metallicYieldLoss.value, style: "tableCell", alignment: "justify" },
              { text: content.production.metallicYieldLoss.comment, style: "tableCell", alignment: "justify", colSpan: 3 },
              {},
              {}
            ],
            [
              { text: "VCB Trips", style: "tableHeader" },
              { text: content.production.vcbTrips ? content.production.vcbTrips.value : "", style: "tableCell", alignment: "justify" },
              { text: content.production.vcbTrips ? content.production.vcbTrips.comment : "", style: "tableCell", alignment: "justify", colSpan: 3 },
              {},
              {}
            ],
          ]
        }
      },
      {
        style: "table",
        color: "#444",
        table: {
          widths: [180, "*", "*", "*", "*"],
          headerRows: 0,
          // keepWithHeaderRows: 1,
          body: [
            [
              { text: "Call Offs", style: "tableCallOffs", colSpan: 5 },
              {},
              {},
              {},
              {},
            ],
            [
              { text: "Incidents", style: "tableHeader" },
              { text: content.callOffs
                ? content.callOffs.incidents.value ? "YES" : "NO"
                : "", style: "tableCell", alignment: "justify" },
              { text: content.callOffs ? content.callOffs.incidents.comment : "", style: "tableCell", alignment: "justify", colSpan: 3 },
              {},
              {}
            ]
          ]
        }
      },
      {
        style: "table",
        color: "#444",
        table: {
          widths: [180, "*", "*", "*", "*"],
          headerRows: 0,
          // keepWithHeaderRows: 1,
          body: [
            [
              { text: "EAF", style: "tableEAF", colSpan: 5 },
              {},
              {},
              {},
              {},
            ],
            [
              { text: "Baghouse", style: "tableHeader" },
              { text: content.eaf.bagHouse.value ? "YES" : "NO", style: "tableCell", alignment: "justify" },
              { text: content.eaf.bagHouse.comment, style: "tableCell", alignment: "justify", colSpan: 3 },
              {},
              {}
            ],
            [
              { text: "B3 ratio (<1.6 or >1.9)", style: "tableHeader" },
              { text: content.eaf.b3Ratio.value, style: "tableCell", alignment: "justify" },
              { text: content.eaf.b3Ratio.comment, style: "tableCell", alignment: "justify", colSpan: 3 },
              {},
              {}
            ],
            [
              { text: "MgO", style: "tableHeader" },
              { text: content.eaf.mgO.value, style: "tableCell", alignment: "justify" },
              { text: content.eaf.mgO.comment, style: "tableCell", alignment: "justify", colSpan: 3 },
              {},
              {}
            ],
            [
              { text: "FeO", style: "tableHeader" },
              { text: content.eaf.feO.value, style: "tableCell", alignment: "justify" },
              { text: content.eaf.feO.comment, style: "tableCell", alignment: "justify", colSpan: 3 },
              {},
              {}
            ]
          ]
        }
      },
      {
        style: "table",
        color: "#444",
        table: {
          widths: [180, "*", "*", "*", "*"],
          headerRows: 0,
          // keepWithHeaderRows: 1,
          body: [
            [
              { text: "LRF", style: "tableLRF", colSpan: 5 },
              {},
              {},
              {},
              {},
            ],
            [
              { text: "Baghouse", style: "tableHeader" },
              { text: content.lrf.bagHouse.value ? "YES" : "NO", style: "tableCell", alignment: "justify" },
              { text: content.lrf.bagHouse.comment, style: "tableCell", alignment: "justify", colSpan: 3 },
              {},
              {}
            ],
            [
              { text: "B3 ratio (<1.6 or >1.9)", style: "tableHeader" },
              { text: content.lrf.b3Ratio.value, style: "tableCell", alignment: "justify" },
              { text: content.lrf.b3Ratio.comment, style: "tableCell", alignment: "justify", colSpan: 3 },
              {},
              {}
            ],
            [
              { text: "MgO", style: "tableHeader" },
              { text: content.lrf.mgO.value, style: "tableCell", alignment: "justify" },
              { text: content.lrf.mgO.comment, style: "tableCell", alignment: "justify", colSpan: 3 },
              {},
              {}
            ],
            [
              { text: "FeO", style: "tableHeader" },
              { text: content.lrf.feO.value, style: "tableCell", alignment: "justify" },
              { text: content.lrf.feO.comment, style: "tableCell", alignment: "justify", colSpan: 3 },
              {},
              {}
            ]
          ]
        }
      },
      {
        style: "table",
        color: "#444",
        table: {
          widths: [180, "*", "*", "*", "*"],
          headerRows: 0,
          // keepWithHeaderRows: 1,
          body: [
            [
              { text: "Caster", style: "tableCaster", colSpan: 5 },
              {},
              {},
              {},
              {},
            ],
            [
              { text: "Non-Free Opens", style: "tableHeader" },
              { text: content.caster.nonFreeOpens.value ? "YES" : "NO", style: "tableCell", alignment: "justify" },
              { text: content.caster.nonFreeOpens.comment, style: "tableCell", alignment: "justify", colSpan: 3 },
              {},
              {}
            ],
            [
              { text: "Breakouts", style: "tableHeader" },
              { text: content.caster.breakouts.value ? "YES" : "NO", style: "tableCell", alignment: "justify" },
              { text: content.caster.breakouts.comment, style: "tableCell", alignment: "justify", colSpan: 3 },
              {},
              {}
            ],
            [
              { text: "Overflow", style: "tableHeader" },
              { text: content.caster.overflow.value ? "YES" : "NO", style: "tableCell", alignment: "justify" },
              { text: content.caster.overflow.comment, style: "tableCell", alignment: "justify", colSpan: 3 },
              {},
              {}
            ],
            [
              { text: "Heats on the tundish", style: "tableHeader" },
              { text: content.caster.heatsOnTheTundish.value, style: "tableCell", alignment: "justify" },
              { text: content.caster.heatsOnTheTundish.comment, style: "tableCell", alignment: "justify", colSpan: 3 },
              {},
              {}
            ]
          ]
        }
      },
      {
        style: "table",
        color: "#444",
        table: {
          widths: [180, "*", "*", "*", "*"],
          headerRows: 0,
          // keepWithHeaderRows: 1,
          body: [
            [
              { text: "Refractories", style: "tableRefractories", colSpan: 5 },
              {},
              {},
              {},
              {},
            ],
            [
              { text: "Tundishes (#)", style: "tableHeader" },
              { text: content.refractories.tundishes.value, style: "tableCell", alignment: "justify" },
              { text: content.refractories.tundishes.comment, style: "tableCell", alignment: "justify", colSpan: 3 },
              {},
              {}
            ],
            [
              { text: "Ladle availables (#)", style: "tableHeader" },
              { text: content.refractories.ladleAvailables.value, style: "tableCell", alignment: "justify" },
              { text: content.refractories.ladleAvailables.comment, style: "tableCell", alignment: "justify", colSpan: 3 },
              {},
              {}
            ],
            [
              { text: "Ladle", style: "tableSubTitle" },
              { text: "Heats", style: "tableSubTitle", alignment: "justify" },
              { text: "Contact Time", style: "tableSubTitle", alignment: "justify" },
              { text: "Status", style: "tableSubTitle", alignment: "justify", colSpan: 2 },
              {}
            ],
            ...content.refractories.ladles.map(l => {

              return [
                { text: l.ladle, style: "tableHeader" },
                { text: l.heats, style: "tableCell", alignment: "justify" },
                { text: l.contactTime, style: "tableCell", alignment: "justify" },
                { text: l.status, style: "tableCell", alignment: "justify", colSpan: 2 },
                {}
              ];
            }),
          ]
        }
      },
      {
        style: "table",
        color: "#444",
        table: {
          widths: [180, "*", "*", "*", "*"],
          headerRows: 0,
          // keepWithHeaderRows: 1,
          body: [
            [
              { text: "Cranes", style: "tableCranes", colSpan: 5 },
              {},
              {},
              {},
              {},
            ],
            [
              { text: "B3", style: "tableHeader" },
              { text: content.cranes.b3.value ? "OK" : "NOT OK", style: "tableCell", alignment: "justify" },
              { text: content.cranes.b3.comment, style: "tableCell", alignment: "justify", colSpan: 3 },
              {},
              {}
            ],
            [
              { text: "C1/C2", style: "tableHeader" },
              { text: content.cranes.c1_c2.value ? "OK" : "NOT OK", style: "tableCell", alignment: "justify" },
              { text: content.cranes.c1_c2.comment, style: "tableCell", alignment: "justify", colSpan: 3 },
              {},
              {}
            ],
            [
              { text: "E1/E3", style: "tableHeader" },
              { text: content.cranes.e1_e3.value ? "OK" : "NOT OK", style: "tableCell", alignment: "justify" },
              { text: content.cranes.e1_e3.comment, style: "tableCell", alignment: "justify", colSpan: 3 },
              {},
              {}
            ],
            [
              { text: "Casey/C&M", style: "tableHeader" },
              { text: content.cranes.casey_CM.value ? "OK" : "NOT OK", style: "tableCell", alignment: "justify" },
              { text: content.cranes.casey_CM.comment, style: "tableCell", alignment: "justify", colSpan: 3 },
              {},
              {}
            ]
          ]
        }
      },
      {
        style: "table",
        color: "#444",
        table: {
          widths: [180, "*", "*", "*", "*"],
          headerRows: 0,
          // keepWithHeaderRows: 1,
          body: [
            [
              { text: "Central Maintenance", style: "tableMaintenance", colSpan: 5 },
              {},
              {},
              {},
              {},
            ],
            [
              { text: "Air Compressors", style: "tableHeader" },
              { text: content.centralMaintenance.airCompressors.value ? "OK" : "NOT OK", style: "tableCell", alignment: "justify" },
              { text: content.centralMaintenance.airCompressors.comment, style: "tableCell", alignment: "justify", colSpan: 3 },
              {},
              {}
            ],
            [
              { text: "Cooling Tower", style: "tableHeader" },
              { text: content.centralMaintenance.coolingTower.value ? "OK" : "NOT OK", style: "tableCell", alignment: "justify" },
              { text: content.centralMaintenance.coolingTower.comment, style: "tableCell", alignment: "justify", colSpan: 3 },
              {},
              {}
            ],
            [
              { text: "HVAC", style: "tableHeader" },
              { text: content.centralMaintenance.hvac.value ? "OK" : "NOT OK", style: "tableCell", alignment: "justify" },
              { text: content.centralMaintenance.hvac.comment, style: "tableCell", alignment: "justify", colSpan: 3 },
              {},
              {}
            ]
          ]
        }
      },
      {
        style: "table",
        color: "#444",
        table: {
          widths: [180, "*", "*", "*", "*"],
          headerRows: 0,
          // keepWithHeaderRows: 1,
          body: [
            [
              { text: "Additional Issues", style: "tableIssues", colSpan: 5 },
              {},
              {},
              {},
              {},
            ],
            ...content.additionalIssues.map(text => {

              return [
                { text, style: "tableCell", colSpan: 5 },
                {},
                {},
                {},
                {}
              ];
            }),
          ]
        }
      },

      {
        style: "table",
        color: "#444",
        table: {
          widths: [180, "*", "*", "*", "*"],
          headerRows: 0,
          // keepWithHeaderRows: 1,
          body: [
            [
              { text: "Millwrights Notes", style: "tableMillwrights", colSpan: 5 },
              {},
              {},
              {},
              {},
            ],
            ...(content.millwrightsNotes ?? [ "" ]).map(text => {

              return [
                { text, style: "tableCell", colSpan: 5 },
                {},
                {},
                {},
                {}
              ];
            }),
          ]
        }
      },
      {
        style: "table",
        color: "#444",
        table: {
          widths: [180, "*", "*", "*", "*"],
          headerRows: 0,
          // keepWithHeaderRows: 1,
          body: [
            [
              { text: "Electricians Notes", style: "tableElectricians", colSpan: 5 },
              {},
              {},
              {},
              {},
            ],
            ...(content.electriciansNotes ?? [ "" ]).map(text => {

              return [
                { text, style: "tableCell", colSpan: 5 },
                {},
                {},
                {},
                {}
              ];
            }),
          ]
        }
      },



      {
        style: "table",
        color: "#444",
        table: {
          widths: [180, "*", "*", "*", "*"],
          headerRows: 0,
          // keepWithHeaderRows: 1,
          body: [
            [
              { text: "SAP Notifications", style: "tableTitle", colSpan: 5, alignment: "center"  },
              { },
              { },
              { },
              { }
            ],

            [
              { text: "Failure Reported to Maintenance in SAP", style: "tableSubTitle", colSpan: 4 },
              { },
              { },
              { },
              { text: "Notification #", style: "tableSubTitle", colSpan: 1 }
            ],

            ...sapNotificationItems
          ]
        }
      },
      {
        style: "table",
        color: "#722",
        table: {
          widths: [80, 100, "*"],
          headerRows: 2,
          dontBreakRows: true,
          // keepWithHeaderRows: 1,
          body: [
            [
              { text: "Events", style: "tableDelays", colSpan: 3 },
              {},
              {}
            ],
            [
              { text: "Count", style: "tableSubTitle", alignment: "justify" },
              { text: "Duration", style: "tableSubTitle", alignment: "justify" },
              { text: "Responsibility\\Area\\Equipment", style: "tableSubTitle", alignment: "justify" }
            ],
            ...(content && content.delays ? content.delays.events ?? [] : []).map(row => {
              const duration = Duration.fromMillis(row.duration * 1000).toFormat("hh:mm:ss");
              let text = row.equipment ? `\\${row.equipment}` : null;

              if (row.area) {
                text = `\\${row.area}${text ?? ""}`;
              }

              text = text ? `${row.responsibility}${text}` : `${row.responsibility}`;

              return [
                { text: row.count, style: "tableCell", alignment: "justify" },
                { text: duration, style: "tableCell", alignment: "justify" },
                { text, style: "tableCell", alignment: "justify" }
              ];
            })
          ]
        }
      },
      {
        style: "table",
        color: "#722",
        table: {
          widths: ["*", "*", "*", "*", "*", "*", "*"],
          headerRows: 1,
          dontBreakRows: true,
          // keepWithHeaderRows: 1,
          body: [
            [
              { text: "Delays (Top 10)", style: "tableDelays", colSpan: 7 },
              {},
              {},
              {},
              {},
              {},
              {},
            ],
            ...delaysData,
          ]
        }
      },
    ],
    styles: {
      header: {
        fontSize: 16,
        bold: true
      },
      table: {
        margin: [0, 5, 0, 15]
      },
      tableHeader: {
        bold: true,
        fontSize: 10,
        color: "black",
      },
      tableSubHeader: {
        bold: true,
        fontSize: 8,
        color: "black"
      },
      tableSubHeader2: {
        bold: true,
        fontSize: 8
      },
      tableCell: {
        fontSize: 10,
        color: "black"
      },
      tableCellVCenter: {
        fontSize: 10,
        color: "black",
        lineHeight: 1.4,
        alignment: "center"
      },
      tableFooter: {
        fontSize: 8,
        color: "#fafafa",
        fillColor: "#263238",
      },
      tableTitle: {
        bold: true,
        fontSize: 10,
        color: "#fafafa",
        fillColor: "#263238",
      },
      tableSubTitle: {
        bold: true,
        fontSize: 10,
        color: "#fafafa",
        fillColor: "#9095A0",
      },
      tableTitleSmall: {
        bold: true,
        fontSize: 9,
        color: "#fafafa",
        fillColor: "#263238",
      },
      tableSafety: {
        bold: true,
        fontSize: 9,
        color: "#fafafa",
        fillColor: "#000000"
      },
      tableQuality: {
        bold: true,
        fontSize: 9,
        color: "#fafafa",
        fillColor: "#c05b09"
      },
      tableProduction: {
        bold: true,
        fontSize: 9,
        color: "#fafafa",
        fillColor: "#4773BF"
      },
      tableDelays: {
        bold: true,
        fontSize: 9,
        color: "#fafafa",
        fillColor: "#772727"
      },
      tableCallOffs: {
        bold: true,
        fontSize: 9,
        color: "#fafafa",
        fillColor: "#772727"
      },
      tableEAF: {
        bold: true,
        fontSize: 9,
        color: "#fafafa",
        fillColor: "#5C803F",
      },
      tableLRF: {
        bold: true,
        fontSize: 9,
        color: "#fafafa",
        fillColor: "#E48242",
      },
      tableCaster: {
        bold: true,
        fontSize: 9,
        color: "#fafafa",
        fillColor: "#A5A5A5",
      },
      tableRefractories: {
        bold: true,
        fontSize: 9,
        color: "#303030",
        fillColor: "#FCD977",
      },
      tableCranes: {
        bold: true,
        fontSize: 9,
        color: "#fafafa",
        fillColor: "#3975B0",
      },
      tableMaintenance: {
        bold: true,
        fontSize: 9,
        color: "#fafafa",
        fillColor: "#3A3838",
      },
      tableIssues: {
        bold: true,
        fontSize: 9,
        color: "#fafafa",
        fillColor: "#3A3838",
      },

      tableMillwrights: {
        bold: true,
        fontSize: 9,
        color: "#fafafa",
        fillColor: "#4773BF",
      },

      tableElectricians: {
        bold: true,
        fontSize: 9,
        color: "#fafafa",
        fillColor: "#E48242",
      }


    },
    footer: (currentPage: number, pageCount: number): any => {
      return { text: `${currentPage} of ${pageCount}`, alignment: "center" };
    }
  };
};